class ScrollButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.target = this.getAttribute("data-target");
    this.offset = 120;
    this.addEventListener("click", () => {
      const target = document.getElementById(this.target);
      if (target) {
        const targetPosition = target.offsetTop - this.offset;
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      }
    });
  }
}

if (!customElements.get("scroll-button")) {
  customElements.define("scroll-button", ScrollButton);
}

class VariantOptionRow extends HTMLElement {  
  constructor() {
    super();
  }

  connectedCallback() {
    this.isSize = this.getAttribute("data-is-size");
    this.isColor = this.getAttribute("data-is-color");
    this.metafieldTextEl = this.querySelector("[data-metafield-text]");
    this.initialValue = this.querySelector("input[checked]").getAttribute("data-attr");
    this.updateMetafieldText(this.initialValue);

    this.querySelectorAll("input").forEach(input => {
      input.addEventListener("click", () => {
        this.updateMetafieldText(input.getAttribute("data-attr"));
      });
    });
  }
  
  updateMetafieldText(text) {
      this.metafieldTextEl.textContent = text;
  }
}

if (!customElements.get("variant-option-row")) {
  customElements.define("variant-option-row", VariantOptionRow);
}

class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.images = this.querySelector("[data-product-card-images]");
    this.variantImages = this.querySelector("[data-variant-images]");
    this.colorSwatches = this.querySelectorAll("[data-color-swatch]");
    this.initColorSwatches();
  }

  initColorSwatches() {
    this.colorSwatches.forEach((swatch) => {
      swatch.addEventListener("click", (e) => {
        e.preventDefault();
        const variantId = swatch.getAttribute("data-variant-id");
        this.showVariantImage(variantId);
      });
    });
  }

  showVariantImage(variantId) {
    if (!this.variantImages) return;

    this.variantImages
      .querySelectorAll("img")
      .forEach((img) => img.classList.add("hidden"));

    const selectedImage = this.variantImages.querySelector(
      `img[data-variant-id="${variantId}"]`
    );
    if (selectedImage) {
      selectedImage.classList.remove("hidden");
    }
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}

class CollectionFeaturedCards extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const prev = this.querySelector("[data-prev]");
    const next = this.querySelector("[data-next]");
    new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      freeMode: true,
      slidesOffsetBefore: 4,
      slidesOffsetAfter: 4,
      navigation: {
        prevEl: prev || null,
        nextEl: next || null,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 40,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }
}

if (!customElements.get("collection-featured-cards")) {
  customElements.define("collection-featured-cards", CollectionFeaturedCards);
}

class AnnouncementBarSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const prev = this.querySelector("[data-prev]");
    const next = this.querySelector("[data-next]");
    const speed = this.getAttribute("data-autoplay-speed");
    new Swiper(this, {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        enabled: speed > 0,
        delay: speed * 1000,
      },
      navigation: {
        prevEl: prev || null,
        nextEl: next || null,
      },
    });
  }
}

if (!customElements.get("announcement-bar-swiper")) {
  customElements.define("announcement-bar-swiper", AnnouncementBarSwiper);
}
